var exports = {
  "D": "RoleAppearance.module__gradient___bkw4cV",
  "K": "RoleAppearance.module__icon___bkw4cV",
};

module.exports = exports;
